import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import ConfirmDialog from './confirm'
import '@mdi/font/css/materialdesignicons.css' 

Vue.use(Vuetify)

const vuetify = new Vuetify({
  icons: {
    iconfont: 'mdi'
  },
  theme: {
    themes: {
      light: {
        primary: '#fa3105',
        secondary: '#b0bec5',
        anchor: '#8c9eff',
      },
    },
  },
})

Vue.use(ConfirmDialog, { vuetify })

export default vuetify
